import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import TemplatesPage from './pages/TemplatesPage';
import HomePage from './pages/HomePage';
import EditorPage from './pages/EditorPage';
import EventsPage from './pages/EventsPage';
import EventFormPage from './pages/EventFormPage';
import EventDetailPage from './pages/EventDetailPage';
import InvitationEditorPage from './pages/InvitationEditorPage';
import GuestListPage from './pages/GuestListPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import TemplateSelectionPage from './pages/TemplateSelectionPage';
import NewInvitationPage from './pages/NewInvitationPage';
import PublicInvitationPage from './pages/PublicInvitationPage';
import ProfilePage from './pages/ProfilePage';

// Private route component
function PrivateRoute({ children }) {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
}

function AppRouter() {
  return (
    <Routes>
      {/* Auth routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      
      {/* Root redirect to homepage */}
      <Route path="/" element={
        <PrivateRoute>
          <Navigate to="/home" replace />
        </PrivateRoute>
      } />
      
      {/* Homepage */}
      <Route path="/home" element={
        <PrivateRoute>
          <HomePage />
        </PrivateRoute>
      } />
      
      {/* Profile page */}
      <Route path="/profile" element={
        <PrivateRoute>
          <ProfilePage />
        </PrivateRoute>
      } />
      
      {/* Templates page */}
      <Route path="/templates" element={
        <PrivateRoute>
          <TemplatesPage />
        </PrivateRoute>
      } />
      
      <Route path="/editor" element={
        <PrivateRoute>
          <EditorPage />
        </PrivateRoute>
      } />
      
      <Route path="/editor/:templateId" element={
        <PrivateRoute>
          <EditorPage />
        </PrivateRoute>
      } />
      
      {/* Event routes */}
      <Route path="/events" element={
        <PrivateRoute>
          <EventsPage />
        </PrivateRoute>
      } />
      
      <Route path="/events/new" element={
        <PrivateRoute>
          <EventFormPage />
        </PrivateRoute>
      } />
      
      <Route path="/events/edit/:eventId" element={
        <PrivateRoute>
          <EventFormPage />
        </PrivateRoute>
      } />
      
      <Route path="/events/:eventId" element={
        <PrivateRoute>
          <EventDetailPage />
        </PrivateRoute>
      } />
      
      {/* Guest list route */}
      <Route path="/events/:eventId/guests" element={
        <PrivateRoute>
          <GuestListPage />
        </PrivateRoute>
      } />
      
      {/* Invitation routes */}
      <Route path="/events/:eventId/invitation/new" element={
        <PrivateRoute>
          <NewInvitationPage />
        </PrivateRoute>
      } />
      
      <Route path="/events/:eventId/invitation/:invitationId/edit" element={
        <PrivateRoute>
          <InvitationEditorPage />
        </PrivateRoute>
      } />
      
      {/* Template selection route */}
      <Route path="/events/:eventId/templates" element={
        <PrivateRoute>
          <TemplateSelectionPage />
        </PrivateRoute>
      } />
      
      {/* Public invitation route */}
      <Route path="/:userId/:eventName/:invitationName" element={<PublicInvitationPage />} />
      <Route path="/invitation/:invitationId" element={<PublicInvitationPage />} />
    </Routes>
  );
}

export default AppRouter; 